module.exports = __webpack_public_path__ + "img/02569387184509f25a590c8c45684db3.png";